var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuyput(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 34H58",
    stroke: "#E6E6E6",
    strokeLinecap: "round",
    strokeDasharray: "4 5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36 38H62.5V42.5H33.5L9 17.5L14 16L36 38Z",
    fill: "#E94C69"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4989 37.9998V37.4998H62.9989V37.9998H62.4989ZM35.9989 37.9998V38.4998C35.8663 38.4998 35.7391 38.4471 35.6453 38.3534L35.9989 37.9998ZM13.9989 15.9998L13.8552 15.5209L14.1413 15.4351L14.3525 15.6462L13.9989 15.9998ZM8.99886 17.4998L8.64175 17.8498L8.0625 17.2587L8.85519 17.0209L8.99886 17.4998ZM33.4989 42.4998V42.9998C33.3645 42.9998 33.2358 42.9457 33.1418 42.8498L33.4989 42.4998ZM62.4989 42.4998H62.9989V42.9998H62.4989V42.4998ZM62.4989 38.4998H35.9989V37.4998H62.4989V38.4998ZM35.6453 38.3534L13.6453 16.3534L14.3525 15.6462L36.3525 37.6462L35.6453 38.3534ZM14.1426 16.4787L9.14253 17.9787L8.85519 17.0209L13.8552 15.5209L14.1426 16.4787ZM9.35597 17.1498L33.856 42.1498L33.1418 42.8498L8.64175 17.8498L9.35597 17.1498ZM33.4989 41.9998H62.4989V42.9998H33.4989V41.9998ZM61.9989 42.4998V37.9998H62.9989V42.4998H61.9989Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32 34H25.5L7 15.5V9.5L32 34Z",
    fill: "#12B16E",
    stroke: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7 10V54",
    stroke: "#E6E6E6",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuyput);
export default __webpack_public_path__ + "static/media/buy put.6b413b15475bb0b773cccd64fe4527b3.svg";
export { ForwardRef as ReactComponent };